import * as React from 'react';

import { FormattedViewModel, TextType } from 'models';

import { SectionHTMLText, SectionPlainText } from './section-text';

interface SectionBodyProps {
  propertyInfoBody: FormattedViewModel;
  hasSubsections?: boolean;
}

export const SectionBody = ({ propertyInfoBody, hasSubsections }: SectionBodyProps) => {
  if (!propertyInfoBody) {
    return null;
  }

  return (
    <div className={`section-body ${hasSubsections && 'all-b-padding-three'}`}>
      {propertyInfoBody.textType === TextType.HTML_TEXT && (
        <SectionHTMLText description={propertyInfoBody.description} topPadding={!hasSubsections && 'all-t-padding-three'} />
      )}
      {propertyInfoBody.textType === TextType.PLAIN_TEXT && (
        <SectionPlainText description={propertyInfoBody.description} topPadding={!hasSubsections && 'all-t-padding-three'} />
      )}
    </div>
  );
};

SectionBody.displayName = 'SectionBody';
